import * as React from 'react';
import MultiSelectModal from '../../../../misc/components/queryTable/MultiSelectModal';
import {
    Query,
    QueryCondition,
    QueryFilter,
    SpirometrySessionMetadata,

    AnalysisSetType
} from "../../../../misc/api/apiTypes";
import { WebPortalLegacyClientInternal } from '../../../../misc/api/WebPortalTokenClient';

export const AnalysisSetTypeFilterMember = "Type.Id";
export const AnalysisSetTypeLabelMember = "Type.Name";
const AnalysisSetTypeFilterQueryCondition = QueryCondition.Equal;
export const AnalysisSetTypeHeader = "Analysis Set Type";

interface AnalysisSetTypeFilterProps {
    fetcher: () => Promise<any>;
    onApply: (member: string, condition: QueryCondition, values: string[]) => void;
    onClose: () => void;
    query: Query<SpirometrySessionMetadata>;
}

const GetQueryFilter = (query: Query<SpirometrySessionMetadata>): QueryFilter => {
    return query.Filters.find(filter => filter.Member === AnalysisSetTypeFilterMember && filter.Condition === AnalysisSetTypeFilterQueryCondition);
}

const AnalysisSetTypeFilterModal = ({ fetcher, onApply, onClose, query }: AnalysisSetTypeFilterProps): JSX.Element => {

    const queryFilter = GetQueryFilter(query) || { Values: [] };

    const [values, setValues] = React.useState<any[]>(queryFilter.Values);

    const [allAnalysisSetTypes, setAllAnalysisSetTypes] = React.useState<AnalysisSetType[]>(null);

    React.useEffect(() => {
        fetcher().then(statuses => {
            setAllAnalysisSetTypes(statuses);
        });
    }, []);

    return (<MultiSelectModal header={AnalysisSetTypeHeader + ' Filter'}
        isLoading={!allAnalysisSetTypes}
        show={true}
        options={allAnalysisSetTypes}
        valueKey={"Id"}
        labelKey={"Name"}
        values={values}
        onChange={(updatedValues) => {
            setValues(updatedValues.length > 0 ? updatedValues.map(v => v.Id) : null);
        }}
        onApply={() => {
            onApply(AnalysisSetTypeFilterMember, AnalysisSetTypeFilterQueryCondition, values);
        }}
        onClear={() => {
            onApply(AnalysisSetTypeFilterMember, AnalysisSetTypeFilterQueryCondition, []);
        }}
        onClose={onClose}
    />)
}

export default AnalysisSetTypeFilterModal;
